import React, { useContext } from 'react';

import Toast from 'react-bootstrap/Toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ERROR, SUCCESS, WARNING } from '../../constants';
import { ToastContext } from '../../context/Toast';

import styles from './Toast.module.scss';

const BootstrapToast = () => {
  const { setShouldRender, shouldRender, type, message } = useContext(ToastContext);

  let color = '';
  let icon = '';

  switch (type) {
    case SUCCESS:
      color = 'text-bg-success';
      icon = 'check-circle';
      break;
    case WARNING:
      color = 'text-bg-warning';
      icon = 'triangle-exclamation';
      break;
    case ERROR:
      color = 'text-bg-danger';
      icon = 'circle-exclamation';
      break;
    default:
      color = '';
      icon = '';
  }

  return (
    <Toast
      autohide
      delay={3000}
      className={`position-fixed bottom-0 end-0 p-3 ${color}`}
      onClose={() => setShouldRender(false)}
      show={shouldRender}
    >
      <Toast.Body className="d-flex gap-3 align-items-center">
        <FontAwesomeIcon icon={icon} size="lg" />

        <div className="d-flex flex-grow-1 align-items-center">
          <span className={styles.message}>{message}</span>

          <button
            aria-label="Close"
            className={`btn-close ${
              type === WARNING ? 'btn-close-black' : 'btn-close-white'
            }`}
            type="button"
            onClick={() => setShouldRender(false)}
            style={{ width: '0.9em', height: '0.9em' }}
          />
        </div>
      </Toast.Body>
    </Toast>
  );
};

export default BootstrapToast;
